import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { ArrowLeftIcon, MailIcon } from 'lucide-react';
import Header from './Header';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSubmitted(true);
      toast.success('Şifre sıfırlama linki e-posta adresinize gönderildi');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-sky-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block">
              <h1 className="text-3xl font-bold gradient-text">
                Advancecash.io
              </h1>
            </Link>
          </div>

          <Card className="p-8 shadow-xl border-0 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <MailIcon className="w-8 h-8 text-green-600" />
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              E-posta Gönderildi
            </h2>
            
            <p className="text-gray-600 mb-6">
              Eğer <strong>{email}</strong> adresi kayıtlıysa, şifre sıfırlama linki e-posta adresinize gönderildi.
            </p>
            
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
              <h3 className="font-semibold text-blue-800 text-sm mb-2">Sonraki Adımlar:</h3>
              <ul className="text-sm text-blue-700 space-y-1">
                <li>• E-posta kutunuzu kontrol edin</li>
                <li>• Spam klasörünü kontrol etmeyi unutmayın</li>
                <li>• Link 1 saat süreyle geçerlidir</li>
                <li>• Link tek kullanımlıktır</li>
              </ul>
            </div>

            <div className="space-y-3">
              <Button 
                onClick={() => setSubmitted(false)}
                variant="outline" 
                className="w-full"
              >
                Tekrar Gönder
              </Button>
              
              <Link to="/login" className="block">
                <Button variant="ghost" className="w-full">
                  <ArrowLeftIcon className="w-4 h-4 mr-2" />
                  Girişe Geri Dön
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-teal-50 via-cyan-50 to-sky-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full">
          {/* Page Title */}
          <div className="text-center mb-8">
          <h2 className="mt-4 text-3xl font-bold text-gray-900">
            Şifrenizi mi Unuttunuz?
          </h2>
          <p className="mt-2 text-gray-600">
            E-posta adresinizi girin, size şifre sıfırlama linki gönderelim
          </p>
        </div>

        {/* Forgot Password Form */}
        <Card className="p-8 shadow-xl border-0">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="email" className="form-label">
                E-posta Adresi
              </Label>
              <Input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="ornek@sirket.com"
                required
              />
              <p className="text-sm text-gray-500 mt-2">
                Kayıtlı e-posta adresinizi girin
              </p>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex justify-center py-3"
            >
              {loading ? (
                <div className="loading-spinner mr-2"></div>
              ) : (
                <MailIcon className="w-4 h-4 mr-2" />
              )}
              <span>{loading ? 'Gönderiliyor...' : 'Şifre Sıfırlama Linki Gönder'}</span>
            </Button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/login" className="inline-flex items-center font-medium text-teal-600 hover:text-teal-500">
              <ArrowLeftIcon className="w-4 h-4 mr-2" />
              Girişe Geri Dön
            </Link>
          </div>
        </Card>

        {/* Security Notice */}
        <Card className="mt-4 p-4 bg-yellow-50 border border-yellow-200">
          <h3 className="text-sm font-semibold text-yellow-800 mb-2">Güvenlik Bildirimi:</h3>
          <div className="text-sm text-yellow-700 space-y-1">
            <p>• Şifre sıfırlama linki 1 saat süreyle geçerlidir</p>
            <p>• Link sadece tek kullanımlıktır</p>
            <p>• Eğer talep etmediyseniz, bu e-postayı görmezden gelin</p>
          </div>
        </Card>
      </div>
    </div>
    </>
  );
};

export default ForgotPassword;